var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SvgIcon',{staticStyle:{"stroke-width":"unset"},attrs:{"viewBox":"0 0 32 32","fill":"none"}},[_c('rect',{attrs:{"x":"1.5","y":"2.5","width":"29","height":"27","rx":"1.5","fill":"white","stroke":"#BBB"}}),_c('rect',{attrs:{"x":"16","y":"5","width":"12","height":"22","rx":"1","fill":"var(--g-color-primary)","stroke":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }